// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { MUST_SEARCH_AT_LEAST_ONE_VALUE } from 'errors'

import {
  assembleQuery,
  fetchRcns,
} from 'helpers/api'

const fetchData = ({ formValues }) => {
  const {
    jobCode,
    rcnNumber,
    serviceContactCode,
  } = formValues

  const search = []

  if (serviceContactCode) {
    search.push({
      field: 'serviceContactCode',
      operator: 'LIKE',
      value: serviceContactCode,
    })
  }

  if (jobCode) {
    search.push({
      field: 'jobCode',
      operator: 'LIKE',
      value: jobCode,
    })
  }

  if (rcnNumber) {
    search.push({
      field: 'rcnNumber',
      operator: 'LIKE',
      value: rcnNumber,
    })
  }

  if (!search.length) {
    throw new Error(MUST_SEARCH_AT_LEAST_ONE_VALUE)
  }

  const query = assembleQuery([{
    field: 'search',
    value: [search],
  }])

  return fetchRcns(query)
}

export default fetchData
